/*
 * The mobile drawer's full menu is not in the page HTML (see snippets/header-drawer.liquid). This fetches the header
 * section through the Section Rendering API, where it renders in full, and swaps the whole <header-drawer> element so the
 * theme's own component binds its handlers. It runs on idle, or earlier on the first pointer, touch or focus near the menu.
 * If the drawer was already opened by then, it is opened again after the swap.
 */
(function () {
  var drawer = document.querySelector('header-drawer[data-section-id]');
  if (!drawer || !drawer.querySelector('[data-lazy-drawer-nav]')) return;

  var started = false;

  function hydrate() {
    if (started) return;
    started = true;
    var id = drawer.getAttribute('data-section-id');
    var url = location.pathname + (location.search ? location.search + '&' : '?') + 'sections=' + encodeURIComponent(id);

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        var doc = new DOMParser().parseFromString(sections[id], 'text/html');
        var fresh = doc.querySelector('header-drawer');
        if (!fresh || !fresh.querySelector('.menu-drawer__navigation li')) return;
        var current = document.querySelector('header-drawer[data-section-id]');
        if (!current) return;
        var wasOpen = current.querySelector('details[open]') !== null;
        var next = document.importNode(fresh, true);
        current.replaceWith(next);
        if (wasOpen) {
          var summary = next.querySelector('summary');
          if (summary) summary.click();
        }
      })
      .catch(function () { started = false; });
  }

  ['pointerenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (name) {
    drawer.addEventListener(name, hydrate, { once: true, passive: true });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(hydrate, { timeout: 3000 });
  } else {
    setTimeout(hydrate, 2500);
  }
})();
